<template>
    <a v-if="type === 1" class="dropdown-item text-green" href="#" @click="onClickFunction()" :title="$t('buttons.exportExcel')">
        <i class="fas fa-file-export"></i>&nbsp;&nbsp;{{ $t('buttons.exportExcel')
        }}</a>
    <div v-if="isDivider" class="dropdown-divider"></div>
</template>

<script>
import config from '@/config/prod.env';
import { read, utils, writeFileXLSX } from 'xlsx';
export default {
    name: "TheExportExcelButton",
    props: {
        onClickParent: {
            type: Function,
            required: true,
        },
        params: {
            type: Object, // Dữ liệu params dạng object
            required: false, // Không bắt buộc
            default: () => ({}),
        },
        type: {
            type: [Number],
            default: 1
        },

        headerExport: {
            required: true,
            type: Array
        },

        fileName: {
            type: String,
            required: true,
        },

        isDivider: {
            type: [Boolean],
            default: false,
        },

    },
    data() {
        return {
            processedData: {}, // Biến lưu trữ giá trị xử lý từ params
        };
    },
    methods: {
        getCurrentDateString() {
            const today = new Date();
            return today.getFullYear() +
                String(today.getMonth() + 1).padStart(2, '0') +
                String(today.getDate()).padStart(2, '0');
        },
        async onClickFunction() {
            try {
                const res = await this.onClickParent({ params: this.processedData }); // Gọi hàm được truyền từ Vuex action
                if (res) {
                    this.exportExcel(res);
                }
                else {
                    // this.$store.dispatch("alert/error", "Lấy dữ liệu thất bại!", { root: true });
                }
            } catch (error) {
                console.error("Lỗi khi gọi Vuex action:", error);

            }
        },

        processParams(params) {
            if (params && typeof params === "object") {
                const result = { ...params }; // Tạo bản sao của params
                const keysToDelete = ["pageNumber", "pageSize", "sort"];
                keysToDelete.forEach((key) => {
                    if (key in result) {
                        delete result[key];
                    }
                });
                return result;
            }
            return {};
        },

        exportExcel(data) {
            const header = this.headerExport.map(col => col.label);

            // Định dạng dữ liệu theo headerExport
            const formattedData = data.map(item => {
                const row = {};
                this.headerExport.forEach(col => {
                    row[col.label] = item[col.key] || ""; // Lấy giá trị từ key, nếu không có thì để trống
                });
                return row;
            });

            // Xuất file Excel
            const ws = utils.json_to_sheet(formattedData, { header: header });
            const wb = utils.book_new();
            utils.book_append_sheet(wb, ws, "Data");

            // Đặt tên file với ngày hiện tại
            const fileName = `${this.fileName}_${new Date().toISOString().slice(0, 10)}.xlsx`;
            writeFileXLSX(wb, fileName);
        }
    },

    watch: {
        params: {
            immediate: true,
            handler(newValue) {
                // Xử lý params mỗi khi thay đổi
                this.processedData = this.processParams(newValue);
            },
        },
    },
    mounted() {
        this.processedData = this.processParams(this.params);
    }
};
</script>

<style></style>
